import Image from 'common/components/Image';
import Token from 'common/models/MyToken';
import { Nullable } from 'common/models/optional';
import { IchiTheme } from 'common/models/theme';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React from 'react';
import { ThemeContext } from 'styled-components';
import { CryptoUtils } from 'utils/cryptoUtils';
import { StyledChainScanTokenLink } from './chainScanTokenLink.style';

type Props = {
  token: Nullable<Token>;
};

const ChainScanTokenLink: React.FC<Props> = (props) => {
  const theme = React.useContext<IchiTheme>(ThemeContext);

  if (props.token == null) {
    return null;
  }

  const { link: scanLink, name } = CryptoUtils.getScannerInfo(
    props.token.chainId,
    props.token.address,
    'token'
  ) as { link: string; name: string };

  return (
    <StyledChainScanTokenLink>
      <OutboundLink target="_blank" href={scanLink || ''}>
        <Image
          src={theme.icons.newWindow}
          alt={`${props.token.symbol} ${name} link`}
        />
      </OutboundLink>
    </StyledChainScanTokenLink>
  );
};

export default ChainScanTokenLink;
